import styled from 'styled-components';
import { Button } from '../Button';
import { Flex } from '../Flex';
export const AlertContainer = styled(Flex) `
	border-width: 1px;
	border-style: solid;

	width: 100%;
`;
export const CloseButton = styled(Button) `
	display: flex;
	align-items: center;
	justify-content: center;

	width: 32px;
	height: 32px;
	background-color: transparent;
`;
//# sourceMappingURL=styles.js.map